<template>
  <v-card class="pa-5 main-grid">
    <v-toolbar flat dense>
      <v-btn icon to="/">
        <v-icon large>mdi-keyboard-backspace</v-icon>
      </v-btn>
    </v-toolbar>
    <v-row>
      <v-col cols="12" md="4" class="pt-4">
        <v-img
          v-if="document.translationDocuments.length > 0"
          :src="imageServerAddress"
          contain
          max-height="600"
        >
          <template v-slot:placeholder>
            <v-layout fill-height align-center justify-center>
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-layout>
          </template>
        </v-img>
      </v-col>
      <v-col cols="12" md="8">
        <v-divider
          :style="this.$vuetify.breakpoint.mdAndUp ? 'display: none;' : ''"
        ></v-divider>
        <v-card-title>{{ document.title }}</v-card-title>
        <v-card-text class="ml-0">
          <v-row>
            <v-col cols="12" md="2" class="pb-0">
              <strong>Document #: </strong>
            </v-col>
            <v-col cols="12" md="10" class="pt-0 pt-md-3">
              {{ document.mci }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="2" class="pb-0">
              <strong>Brands: </strong>
            </v-col>
            <v-col cols="12" md="10" class="pt-0 pt-md-3">
              {{ brands }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="2" class="pb-0">
              <strong>Languages: </strong>
            </v-col>
            <v-col cols="12" md="10" class="pt-0 pt-md-3">
              <v-row
                v-for="(item, index) in document.translationDocuments"
                :key="index"
                class="ml-0"
              >
                <router-link
                  :to="{
                    name: 'documentDetails',
                    params: { id: item.documentId, language: item.language }
                  }"
                  >{{ item.languageNavigation.description }}
                </router-link>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="2" class="pr-0 pb-0">
              <strong>Product Area:</strong>
            </v-col>
            <v-col cols="12" md="10" class="pt-0 pt-md-3">
              {{ document.productAreaNavigation.description }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="2" class="pr-0 pb-0">
              <strong>Document Type:</strong>
            </v-col>
            <v-col cols="12" md="10" class="pt-0 pt-md-3">
              {{ document.typeNavigation.description }}
            </v-col>
          </v-row>
          <v-row>
            <v-btn class="mt-6" color="success" :href="docLink" target="_blank">
              View
            </v-btn>
            <v-btn
              v-if="isAuthorized && !isIE"
              class="mt-6 ml-3"
              color="warning"
              @click.stop="modify"
            >
              Modify
            </v-btn>
            <v-spacer />
          </v-row>
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import axios from 'axios';

export default {
  data() {
    return {
      document: {
        id: '',
        brand: [
          {
            brandDescription: ''
          }
        ],
        languageNavigation: {
          description: ''
        },
        productAreaNavigation: {
          description: ''
        },
        typeNavigation: {
          description: ''
        },
        translationDocuments: []
      },
      docLink: ''
    };
  },
  computed: {
    ...mapState('languages', ['languageFilterValue']),
    ...mapState('user', ['isAuthorized']),
    ...mapState(['isIE']),
    brands() {
      return this.document.brand.map(b => b.brandDescription).join(', ');
    },
    translationDoc() {
      return this.document.translationDocuments.find(
        x => x.language == this.$route.params.language
      );
    },
    imageServerAddress() {
      let fileName = this.translationDoc.fileName;
      fileName = fileName.substr(0, fileName.lastIndexOf('.')) + '.jpg';
      return process.env.VUE_APP_API_SERVER + '/Image/' + fileName;
    }
  },
  watch: {
    $route: 'fetchDocumentData'
  },
  created() {
    this.fetchDocumentData();
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar']),
    fetchDocumentData() {
      axios
        .get(
          '/Document/' +
            this.$route.params.id +
            '/' +
            this.$route.params.language
        )
        .then(response => {
          this.document = response.data;
          this.document.translationDocuments.sort((a, b) => {
            if (
              a.languageNavigation.description <
              b.languageNavigation.description
            ) {
              return -1;
            } else if (
              a.languageNavigation.description >
              b.languageNavigation.description
            ) {
              return 1;
            } else {
              return 0;
            }
          });
          this.setPDF();
        })
        .catch(error => {
          this.showSnackbar({ text: error, color: 'error', timeout: 5000 });
        });
    },
    setPDF() {
      axios
        .get('/DocLibFile/GetFileName/' + this.translationDoc.documentLink)
        .then(response => {
          if (process.env.NODE_ENV === 'development') {
            this.docLink =
              'https://stg.pub.teleflex.com/document-library/files/' +
              response.data;
          } else {
            this.docLink = window.location.origin + '/files/' + response.data;
          }
        })
        .catch(error => {
          this.showSnackbar({ text: error, color: 'error' });
        });
    },
    modify() {
      this.$router.push({
        name: 'modify',
        params: {
          id: this.document.id
        }
      });
    },
    languageLink(translationDoc) {
      return this.$route.path + '/' + translationDoc.documentId;
    }
  }
};
</script>

<style>
.main-grid {
  background-color: whitesmoke;
  min-width: 100%;
}
.pdf-preview {
  max-width: 10em;
  max-height: 12em;
  overflow: hidden;
}
.v-card__title {
  word-break: break-word;
}
</style>
